//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class StripePaymentSourceSetupDisplayItem extends ItemBase {
    ClientSecret: string | null = null;
    PaymentSourceJWT: string | null = null;
    VerificationURL: string | null = null;

    constructor(initializer?: Partial<StripePaymentSourceSetupDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "StripePaymentSourceSetupDisplayItem";
}
